import React, { useContext, useEffect } from "react";

import Accordion from "../accordion";
import AttributeRow from "./compare-table/attribute-row";
import QaAttributeRow from "components/attributes/compare-table/qa-attribute-row";
import { CodingSizeAttributes } from "./compare-table/coding-size-attributes";
import { useGroupPairing } from "./hooks/use-group-pairing";
import { TaskType } from "shared/taskTypeMap";
import { useColumnTemplate } from "../../shared/hooks/use-column-template";
import { AttributesContext } from "../../contexts/attributes";
import { AttributePairValidationProvider } from "./contexts/attribute-validation-provider";
import { attributeGroupNames } from "./lib/constants";

const AttributeList = ({
    attributeGroups,
    attributesSubgroups,
    attributesByGroup, // TODO: should  this be always populated?
    references,
    removeAttribute,
    readOnlyOverride,
    taskType,
    columnWidths,
    reloadAttributes,
    isReadOnlyAdd,
    isReadOnlyEdit,
    isReadOnlyDelete,
    roleLabels,
    refetchCoderRoles,
    hasRedo,
    isCompleted,
    isFinalized,
    roleTaskType,
    isBrandVerified,
    isQa,
}) => {
    const { refreshAttributes } = useContext(AttributesContext);
    const gridTemplate = useColumnTemplate(references.length + 2, columnWidths, references.length === 0);

    useEffect(() => {
        if (refreshAttributes && !!attributesSubgroups && reloadAttributes) {
            reloadAttributes();
        }
    }, [refreshAttributes, attributesSubgroups, reloadAttributes]);

    const accordionGroup = attributeGroups.map(({ name, label }) => {
        if (taskType === TaskType.CODING_QA) {
            const qaRole = roleLabels.find((role) => role.type === "qa");

            return (
                <div
                    key={`group${name}`}
                    label={label}
                    anchor={name}
                >
                    <div className="product-compare">
                        {attributesByGroup[name].map((attr) => {
                            return (
                                <QaAttributeRow
                                    key={`attributerow_${attr.uuid}`}
                                    attr={attr}
                                    columnWidths={columnWidths}
                                    references={references}
                                    readOnlyOverride={readOnlyOverride}
                                    roleLabels={roleLabels}
                                    qaAttributes={qaRole.attributes}
                                    refetchCoderRoles={refetchCoderRoles}
                                    hasRedo={hasRedo}
                                    isReadOnlyAdd={isReadOnlyAdd}
                                    isReadOnlyEdit={isReadOnlyEdit}
                                    isReadOnlyDelete={isReadOnlyDelete}
                                    isBrandVerified={isBrandVerified}
                                    isQa={isQa}
                                />
                            );
                        })}
                    </div>
                </div>
            );
        }

        // if subgroups are available
        if (attributesSubgroups[name]) {
            const updatedAnchor =
                name === attributeGroupNames.FQA_SIZE
                    ? attributeGroupNames.CODING_SIZE
                    : name === attributeGroupNames.FQA_IDENTIFYING
                      ? attributeGroupNames.CODING_IDENTIFYING
                      : name;

            return (
                <div
                    key={`group${name}`}
                    label={label}
                    anchor={updatedAnchor}
                >
                    <div className="product-compare">
                        <div style={gridTemplate}>
                            <CodingSizeAttributes
                                columnWidths={columnWidths}
                                subGroups={attributesSubgroups[name]}
                                attributes={attributesByGroup ? attributesByGroup[name] : []}
                                removeAttribute={removeAttribute}
                                references={references}
                                readOnlyOverride={readOnlyOverride}
                                taskType={taskType}
                                isReadOnlyAdd={isReadOnlyAdd}
                                isReadOnlyEdit={isReadOnlyEdit}
                                isReadOnlyDelete={isReadOnlyDelete}
                                isCompleted={isCompleted || isFinalized}
                                isBrandVerified={isBrandVerified}
                                isQa={isQa}
                            />
                        </div>
                    </div>
                </div>
            );
        }

        // TODO: FIX!!!
        // eslint-disable-next-line react-hooks/rules-of-hooks
        const codingGroups = useGroupPairing(attributesByGroup[name], taskType);

        return (
            <div
                key={`group${name}`}
                label={label}
                className="product-compare"
                anchor={name}
            >
                {codingGroups &&
                    codingGroups.map((group) => {
                        return (
                            <AttributePairValidationProvider key={`${group[0].uuid}`}>
                                {group.map((attr) => {
                                    const isVisible =
                                        attr.hiddenAttributeTaskInfo === null ||
                                        (attr.hiddenAttributeTaskInfo && attr.hiddenAttributeTaskInfo.filter((n) => n === taskType).length === 0);

                                    if (isVisible) {
                                        return (
                                            <AttributeRow
                                                key={`attributerow_${attr.uuid}`}
                                                attr={attr}
                                                removeAttribute={removeAttribute}
                                                columnWidths={columnWidths}
                                                readOnlyOverride={readOnlyOverride}
                                                references={references}
                                                isReadOnlyAdd={isReadOnlyAdd}
                                                isReadOnlyEdit={isReadOnlyEdit}
                                                isReadOnlyDelete={isReadOnlyDelete}
                                                isCompleted={isCompleted || isFinalized}
                                                roleTaskType={roleTaskType}
                                                isBrandVerified={isBrandVerified}
                                                isQa={isQa}
                                            />
                                        );
                                    }

                                    return null;
                                })}
                            </AttributePairValidationProvider>
                        );
                    })}
            </div>
        );
    });

    const noIndentClass = taskType === TaskType.CODING_QA ? "-no-indent" : "";

    return (
        <div className="attribute-content">
            <Accordion
                className={`accordion-attributes ${noIndentClass}`}
                openAll={!!isBrandVerified}
            >
                {accordionGroup}
            </Accordion>
        </div>
    );
};

AttributeList.defaultProps = {
    attributeGroups: [],
    referenceKeys: [],
    references: [],
};

export default AttributeList;
